// TODO : split qquick payments in different components
import React, { useState, useCallback, useEffect, useRef } from 'react'
import { useModal } from 'react-modal-hook'
import { useSelector, useDispatch } from 'react-redux'
import { Formik, Field, Form } from 'formik'
import QuickPayService from '../../../services/quick-pay.service'
import { QuickPaySchema } from '../../../schemas/quick-pay'
import InputError from '../../../components/InputError/InputError'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../../components/Modal/Modal'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import NeoInput from '../../../components/NeoInput/NeoInput'
import NeoButton from '../../../components/NeoButton/NeoButton'
import { useTranslation } from 'react-i18next'
import {
  SIDENAV_KEYS,
  DEPOSITS_KEYS,
  REQUESTS_KEYS,
  DIALOG_KEYS,
  BENEFICIARY_TRANSFER_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import { NeoLoader } from '../../../components/FormComponents'
import NumberFormat from 'react-number-format'
import { setAccRefresh, setRemarks } from '../../../actions'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import AccountDisplay from '../../../components/account-display/account-display'
import { useHistory, useLocation } from 'react-router-dom'
import {
  getFeatureListSelector,
  carouselCurrentItemSelector,
  remarksSelector,
} from '../../../selectors'
import config from 'custom/config/environment'
import clientAdditionalFields from 'custom/config/quickTransfer.additionalFields.json'

import validationConfig from 'custom/config/validation.config.json'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
const instantTransferConfig = validationConfig['quickPay']

export default function InstantTransfer() {
  const history = useHistory()
  const location = useLocation()
  const [showCard, setShowCard] = useState(true)
  const [stage, setStage] = useState(1)
  const sourceAccDetails = useSelector(carouselCurrentItemSelector)
  const current = useSelector(carouselCurrentItemSelector)
  const featureList = useSelector(getFeatureListSelector)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [randomKey, setRandomKeys] = useState('')
  const [otpEnable, setOtpEnable] = useState(false)
  const { t } = useTranslation()
  const inputFile = useRef(null)
  const [imgLocation, setImgLocation] = useState('')
  const [responseValues, setResponseValues] = useState({})
  const [otp, setOtp] = useState('')
  const [banks, setBanks] = useState({})
  const [requestType, setRequestType] = useState('')
  const [selectedBank, setSelectedBank] = useState('')
  const [formValues, setFormValues] = useState({
    accountType: '',
    bank: '',
    branch: '',
    accountNumber: '',
    confirmAccountNumber: '',
    amount: '',
    remarks: '',
    beneficiaryName: '',
    bankName: '',
    branchName: '',
    addBene: false,
    customRemarks: '',
  })
  const remarksList = useSelector(remarksSelector)
  const dispatch = useDispatch()
  const [error, setError] = useState({})
  const [data, setData] = useState({})
  const [additionalFieldValues, setAdditionalFieldValues] = useState({})
  const [additionalFieldValidations, setAdditionalFieldValidations] = useState({})
  const [successResponse, setSuccessResponse] = useState({})
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code}</b> : {error?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  const transferTypes = {
    IAT: t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.INTERNAL),
    DDACC: t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.DDACC_TRANSFER),
    RTGS: t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.RTGS_TRANSFER),
    REGION: t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.REGIONAL),
  }
  const fetchPreFormData = useCallback(async () => {
    try {
      const response = await QuickPayService.getAllBanks()
      const bankNames = {}
      if (response.length) {
        response.map((value) => {
          if (Object.keys(bankNames).includes(value.bankName)) {
            bankNames[value.bankName].push({
              bankCode: value.bankCode,
              address: value.branchDesc,
              bicCode: value.bicCode,
              sortCode: value.sortCode,
            })
          } else {
            bankNames[value.bankName] = [
              {
                bankCode: value.bankCode,
                address: value.branchDesc,
                bicCode: value.bicCode,
                sortCode: value.sortCode,
              },
            ]
          }
          return value
        })
      }
      setBanks(bankNames)
    } catch (err) {
      setMessage(err.message || t(REQUESTS_KEYS.SELECT_REQUEST_KEYS.ERROR))
    }
  }, [])

  const getAdditionalFields = useCallback((details) => {
    try {
      if (Object.keys(clientAdditionalFields).length > 0 && clientAdditionalFields[details]) {
        const initialValues = {}
        const validations = {}
        clientAdditionalFields[details].forEach((item) => {
          initialValues[item.fieldName] = ''
          validations[item.fieldName] = item.mandatory
            ? Yup.string().required(`${t(item.fieldLabel)} ${t(PAYMENT_KEYS.IS_REQUIRED)}`)
            : Yup.string().optional()
        })
        setAdditionalFieldValidations(validations)
        setAdditionalFieldValues(initialValues)
        // const yepSchema = clientAdditionalFields[productDetails?.category].reduce(createYupSchema, {})
      }
    } catch (err) {}
  }, [])

  useEffect(() => {
    location.pathname.includes('/beneficiary-transfers') &&
      setData({ url: '/beneficiary-transfers', breadCrumb: 'TRANSFERS_INSTANT_TRANSFER' })
    location.pathname.includes('/accounts') &&
      setData({ url: '/accounts', breadCrumb: 'ACCOUNTS_INSTANT_TRANSFER' })
    fetchPreFormData()
  }, [fetchPreFormData])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return (
          <NeoOTP otp={otp} setOTP={setOtp} onSubmit={confirmInstantTransfer} loading={loading} />
        )
      case 4:
        return (
          <NeoSuccess
            onClick1={() =>
              BeneficiaryTransferService.downLoadReport({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'FUNDTRANSFER',
              })
            }
            module='DOWNLOAD_RECEIPT'
            message={message}
            linkPath={`${data.url}/quick-pay`}
          />
        )
      default:
        return renderForm()
    }
  }

  const verifyInstantTransfer = useCallback(
    async (data, { setSubmitting }) => {
      const additionalValues = {}
      if (
        Object.keys(clientAdditionalFields).length > 0 &&
        clientAdditionalFields[data.accountType]
      ) {
        clientAdditionalFields[data.accountType].forEach((item) => {
          additionalValues[item.fieldName] = data[item.fieldName]
        })
      }
      if (data.accountType === 'IAT') {
        if (featureList['FT_INTERNAL'][sourceAccDetails['accountType']] === 'N') {
          setError({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }
      }
      if (data.accountType === 'DDACC') {
        if (featureList['FT_DDACC'][sourceAccDetails['accountType']] === 'N') {
          setError({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }
      }

      if (data.accountType === 'RTGS' || data.accountType === 'REGION') {
        if (featureList['FT_RTGS'][sourceAccDetails['accountType']] === 'N') {
          setError({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }
      }

      if (data.amount === '0.00' || data.amount === '.00') {
        return
      }
      setLoading(true)
      setSubmitting(true)
      let branchDetails = {}
      if (data.accountType !== 'IAT') {
        if (config.BENE_BRANCH && config.CLIENT_NAME !== 'NBS') {
          branchDetails = banks[data.bankName].filter((ele) => ele.address === data.branchName)[0]
        } else {
          branchDetails = banks[data.bankName][0]
        }
      }
      setFormValues({ ...data, ...branchDetails })
      try {
        const response = await QuickPayService.fundTransferVerify({
          fin: {
            srcAccount: sourceAccDetails?.accountNo,
            srcAccBranch: sourceAccDetails?.brnCode,
            srcAccCcy: sourceAccDetails?.currency,
            destAccount: data.accountNumber,
            destAccBranch: '',
            destAccCcy: '',
            destBankName: data.bankName,
            bicCode: data.accountType !== 'IAT' ? branchDetails.bicCode : '',
            sortCode: data.accountType !== 'IAT' ? branchDetails.sortCode : '',
            bankCode: data.accountType !== 'IAT' ? branchDetails.bankCode : '',
            txnCurrency: config.LOCAL_CURRENCY_CODE,
            amount: data.amount,
            remarks: data.remarks != 'Custom' ? data.remarks : data.customRemarks,
          },
          nfin: {
            transferType: data.accountType,
            beneId: 0,
            scheduled: '',
            scheduledDate: '',
            beneficiaryName: data.beneficiaryName,
            beneficiaryMail: '',
            beneficiaryMobile: '',
            addBeneficiary: data.addBene,
          },
          cdf: {
            FXREFNO: '',
            ...additionalValues,
          },
          requestId: `FTVERIFY${data.accountType}`,
          module: 'FUNDTRANSFER',
        })

        if (response.status === 200) {
          setOtpEnable(response.data['otpEnabled'])
          setResponseValues(response.data)
          setSubmitting(false)
          setLoading(false)
          setStage(2)
        }
      } catch (err) {
        setSubmitting(false)
        setLoading(false)
      }
    },
    [banks, showModal, sourceAccDetails, featureList],
  )

  const confirmInstantTransfer = useCallback(async () => {
    setLoading(true)
    try {
      const additionalValues = {}

      if (
        Object.keys(clientAdditionalFields).length > 0 &&
        clientAdditionalFields[formValues.accountType]
      ) {
        clientAdditionalFields[formValues.accountType].forEach((item) => {
          additionalValues[item.fieldName] = formValues[item.fieldName]
        })
      }

      const response = await QuickPayService.fundTransferConfirm({
        fin: {
          srcAccount: sourceAccDetails?.accountNo,
          srcAccBranch: sourceAccDetails?.brnCode,
          srcAccCcy: sourceAccDetails?.currency,
          destAccount: formValues.accountNumber,
          destAccBranch: formValues.accountType !== 'IAT' ? '' : responseValues.destBranch,
          destAccCcy: formValues.accountType !== 'IAT' ? '' : responseValues.destCurrency,
          destBankName: formValues.bankName,
          bicCode: formValues.accountType !== 'IAT' ? formValues.bicCode : '',
          sortCode: formValues.accountType !== 'IAT' ? formValues.sortCode : '',
          bankCode: formValues.accountType !== 'IAT' ? formValues.bankCode : '',
          txnCurrency: config.LOCAL_CURRENCY_CODE,
          amount: formValues.amount,
          remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
        },
        nfin: {
          transferType: formValues.accountType,
          beneId: 0,
          scheduled: '',
          scheduledDate: '',
          beneficiaryName:
            formValues.accountType === 'IAT' ? responseValues.beneName : formValues.beneficiaryName,
          beneficiaryMail: formValues.beneficiaryEmail || '',
          beneficiaryMobile: formValues.beneficiaryMobile || '',
          addBeneficiary: formValues.addBene,
          otp: responseValues.otpEnabled ? otp : '0000',
        },
        cdf: {
          FXREFNO: '',
          ...additionalValues,
        },
        requestId: `FTCONFIRM${formValues.accountType}`,
        module: 'FUNDTRANSFER',
      })
      if (response.status === 200) {
        dispatch(setAccRefresh(true))
        setSuccessResponse(response.data)
        setMessage(response.data.message)
        setStage(4)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
    setLoading(false)
  }, [formValues, banks, otp, responseValues, sourceAccDetails])

  function renderAccountField(errors, touched, setFieldValue, values, handleChange) {
    if (requestType === 'DDACC' || requestType === 'RTGS' || requestType === 'REGION') {
      return (
        <>
          <div className='form-group col-12'>
            <NeoInput
              tabIndex='2'
              showAsterisk={instantTransferConfig['isAccountNoRequired']}
              text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.ACCOUNTNO)}
              onChange={handleChange}
              maxLength={20}
              mode='single'
              type='password'
              name='accountNumber'
              onKeyPress={(event) => {
                if (
                  !(event.charCode >= 48 && event.charCode <= 57) &&
                  !(event.charCode >= 65 && event.charCode <= 90) &&
                  !(event.charCode >= 97 && event.charCode <= 122) &&
                  event.charCode !== 32
                ) {
                  event.preventDefault()
                }
              }}
            />
            <InputError text={errors.accountNumber} touched={touched.accountNumber} />
          </div>

          <div className='form-group col-12'>
            <NeoInput
              tabIndex='3'
              showAsterisk={instantTransferConfig['isConfirmAccountNoRequired']}
              text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.CONFIRM_ACCOUNT_NUMBER)}
              onChange={handleChange}
              name='confirmAccountNumber'
              value={values.confirmAccountNumber}
              maxLength={20}
              onKeyPress={(event) => {
                if (
                  !(event.charCode >= 48 && event.charCode <= 57) &&
                  !(event.charCode >= 65 && event.charCode <= 90) &&
                  !(event.charCode >= 97 && event.charCode <= 122) &&
                  event.charCode !== 32
                ) {
                  event.preventDefault()
                }
              }}
            />
            <InputError text={errors.confirmAccountNumber} touched={touched.confirmAccountNumber} />
          </div>
        </>
      )
    }
    return (
      <>
        <div className='form-group col-12'>
          <NeoInput
            tabIndex='2'
            showAsterisk={instantTransferConfig['isAccountNoRequired']}
            text={t(SIDENAV_KEYS.SERVICEREQUEST_KEYS.ACCOUNTNO)}
            onChange={(value) => {
              setFieldValue('accountNumber', value?.value)
            }}
            mode='password'
            name='accountNumber'
            maxLength={config.ACC_NO_LENGTH}
          />
          <InputError text={errors.accountNumber} touched={touched.accountNumber} />
        </div>

        <div className='form-group col-12'>
          <NeoInput
            tabIndex='3'
            showAsterisk={instantTransferConfig['isConfirmAccountNoRequired']}
            text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.CONFIRM_ACCOUNT_NUMBER)}
            // onChange={handleChange}
            name='confirmAccountNumber'
            onChange={(value) => {
              setFieldValue('confirmAccountNumber', value?.value)
            }}
            value={values.confirmAccountNumber}
            mode='onlyNumber'
            maxLength={config.ACC_NO_LENGTH}
          />
          <InputError text={errors.confirmAccountNumber} touched={touched.confirmAccountNumber} />
        </div>
      </>
    )
  }

  function renderAdditionalFieldsForSpecificClient(
    errors,
    touched,
    handleChange,
    values,
    setFieldValue,
  ) {
    return (
      <>
        {Object.keys(clientAdditionalFields).length > 0 &&
          clientAdditionalFields[values?.accountType] && (
            <>
              {clientAdditionalFields[values?.accountType].map((field, index) => (
                <>
                  <div className='form-group' key={index}>
                    {/* {field.type === 'onlyNumber' && ( */}
                    <NeoInput
                      tabIndex={index}
                      showAsterisk={field.mandatory}
                      text={t(field.fieldLabel)}
                      onChange={(value) => {
                        console.log(value)
                        setFieldValue(field?.fieldName, value?.value || value?.target?.value)
                      }}
                      mode={field.type}
                      name={field.fieldName}
                      list={field.list}
                    />
                    {/* )} */}
                    <InputError
                      text={errors[field?.fieldName]}
                      touched={touched[field?.fieldName]}
                    />
                  </div>
                </>
              ))}
            </>
          )}
      </>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.INSTANTTRANSFER)}
        </div>

        <Formik
          initialValues={{ ...formValues, ...additionalFieldValues }}
          enableReinitialize
          validationSchema={QuickPaySchema}
          onSubmit={verifyInstantTransfer}>
          {({ isSubmitting, errors, touched, handleChange, values, setFieldValue }) => (
            <Form>
              <AccountDisplay currentAccountDetail={current} />

              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ACCOUNT_TYPE)}{' '}
                    {instantTransferConfig['isTransferTypeRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'1'}
                    as='select'
                    name='accountType'
                    className='form-control'
                    onChange={(e) => {
                      setRequestType(e.target.value)
                      setFieldValue('accountNumber', '')
                      setFieldValue('confirmAccountNumber', '')
                      handleChange(e)
                      getAdditionalFields(e.target.value)
                    }}>
                    <option value='' />
                    {config.TRANSFER_TYPES.map((option, index) => (
                      <option value={option} key={index}>
                        {transferTypes[option]}
                      </option>
                    ))}
                  </Field>
                  <InputError text={errors.accountType} touched={touched.accountType} />
                </div>
              </div>

              <div className='row'>
                {renderAccountField(errors, touched, setFieldValue, values, handleChange)}
              </div>

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                values.accountType === 'REGION') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='4'
                      showAsterisk={instantTransferConfig['isBeneNameRequired']}
                      text={t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME)}
                      onChange={handleChange}
                      name='beneficiaryName'
                      value={values.beneficiaryName}
                      minLength={2}
                      maxLength={32}
                      onKeyPress={(event) => {
                        if (
                          !(event.charCode >= 65 && event.charCode <= 90) &&
                          !(event.charCode >= 97 && event.charCode <= 122) &&
                          event.charCode !== 32
                        ) {
                          event.preventDefault()
                        }
                      }}
                    />
                    <InputError text={errors.beneficiaryName} touched={touched.beneficiaryName} />
                  </div>
                </div>
              )}

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                values.accountType === 'REGION') && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='5'
                      showAsterisk={instantTransferConfig['isBeneBankRequired']}
                      mode='select'
                      text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BANK)}
                      name='bankName'
                      onChange={(e) => {
                        setSelectedBank(e.target.value)
                        handleChange(e)
                      }}
                      list={Object.keys(banks)}
                    />
                    <InputError text={errors.bankName} touched={touched.bankName} />
                  </div>

                  {config.BENE_BRANCH && (
                    <div className='form-group col-12'>
                      {config.CLIENT_NAME !== 'NBS' ? (
                        <NeoInput
                          tabIndex='6'
                          showAsterisk={instantTransferConfig['isBeneBranchRequired']}
                          mode='select'
                          text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BRANCH1)}
                          name='branchName'
                          onChange={handleChange}
                          list={banks[selectedBank]}
                          keyValue='address'
                          waitCondition={selectedBank.length > 0}
                        />
                      ) : (
                        <NeoInput
                          showAsterisk={instantTransferConfig['isBeneBranchRequired']}
                          text={t(REQUESTS_KEYS.STANDING_INSTRUCTION_KEYS.CREATE_KEYS.BRANCH1)}
                          name='branchName'
                          value={values.branchName}
                          onChange={handleChange}
                        />
                      )}
                      <InputError text={errors.branchName} touched={touched.branchName} />
                    </div>
                  )}
                </div>
              )}

              <div className='form-group'>
                {renderAdditionalFieldsForSpecificClient(
                  errors,
                  touched,
                  handleChange,
                  values,
                  setFieldValue,
                )}
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='7'
                    showAsterisk={instantTransferConfig['isAmountRequired']}
                    mode='amount'
                    text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('amount', values.value)
                    }}
                    name='txnAmount'
                  />
                  <InputError text={errors.amount} touched={touched.amount} />
                  <InputError
                    text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                    touched={values.amount === '0.00' || values.amount === '.00'}
                  />
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='8'
                    showAsterisk={instantTransferConfig['isRemarksRequired']}
                    text={t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS)}
                    mode='select'
                    name='remarks'
                    onChange={(e) => {
                      handleChange(e)
                    }}
                    list={remarksList}
                    keyValue={null}
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>
              </div>

              {values.remarks === 'Custom' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='9'
                      showAsterisk={instantTransferConfig['isCustomRemarksRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                      onChange={handleChange}
                      value={values.customRemarks}
                      name='customRemarks'
                      maxLength={config.REMARKS_MAX}
                    />
                    <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                  </div>
                </div>
              )}

              <div className='row'>
                <div className='form-group col-12 text-right'>
                  <div className='form-check'>
                    <Field
                      tabIndex={'10'}
                      as='input'
                      type='checkbox'
                      className='form-check-input'
                      name='addBene'
                    />
                    <label className='form-check-label control-label' htmlFor='gridCheck'>
                      {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.TITLE)}
                    </label>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='form-group col-12'>
                  {loading ? (
                    renderLoading()
                  ) : (
                    <NeoButton
                      tabIndex='11'
                      type='submit'
                      disabled={loading}
                      text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SUBMIT)}
                      mode='newDesign'
                    />
                  )}
                </div>
              </div>

              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'12'}
                  onClick={() => history.push(`${data.url}/quick-pay`)}>
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>

              {(values.accountType === 'DDACC' ||
                values.accountType === 'RTGS' ||
                values.accountType === 'REGION') &&
                config.CLIENT_NAME !== 'NBS' && (
                  <div className='row'>
                    <div className='form-group col-12'>
                      <p className='small font-weight-600'>
                        {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NOTE)}
                      </p>
                    </div>
                  </div>
                )}
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirm() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3> {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.CONFIRMINSTANTTRANSFER)}</h3>

        <AccountDisplay currentAccountDetail={current} />

        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.TRANSFER_TYPE)}
          </h6>
          <h6 className='value'>{transferTypes[formValues.accountType]}</h6>
        </div>

        {formValues.accountType !== 'IAT' && (
          <div>
            <div>
              <h6 className='label'>
                {' '}
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.QUICKPAY_BANK_NAME)}
              </h6>
              <h6 className='value'>{formValues.bankName}</h6>
            </div>
            {config.BENE_BRANCH && (
              <>
                <div>
                  <h6 className='label'>
                    {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.QUICKPAY_BRANCH_NAME)}
                  </h6>
                  <h6 className='value'>{formValues.branchName}</h6>
                </div>
                <div>
                  <h6 className='label'>
                    {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BIC)}
                  </h6>
                  <h6 className='value'>{formValues.bicCode}</h6>
                </div>
                <div>
                  <h6 className='label'>
                    {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.SORT)}
                  </h6>
                  <h6 className='value'>{formValues.sortCode}</h6>
                </div>
              </>
            )}
            <div>
              <h6 className='label'>
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME1)}
              </h6>
              <h6 className='value'>{formValues.beneficiaryName}</h6>
            </div>
          </div>
        )}

        {formValues.accountType === 'IAT' && (
          <div>
            <div>
              <h6 className='label'>
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.NAME1)}
              </h6>
              <h6 className='value'>{responseValues.beneName}</h6>
            </div>
          </div>
        )}

        <div>
          <h6 className='label'>
            {' '}
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BEN_ACCOUNT)}
          </h6>
          <h6 className='value'>{formValues.accountNumber}</h6>
        </div>

        {formValues.accountType === 'IAT' && (
          <div>
            <div>
              <h6 className='label'>
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BEN_BRANCH)}{' '}
              </h6>
              <h6 className='value'>{responseValues.destBranch}</h6>
            </div>
            <div>
              <h6 className='label'>
                {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.BEN_CURRENCY)}
              </h6>
              <h6 className='value'>{responseValues.destCurrency}</h6>
            </div>
          </div>
        )}

        {Object.keys(clientAdditionalFields).length > 0 &&
          clientAdditionalFields[formValues?.accountType] && (
            <>
              {clientAdditionalFields[formValues?.accountType].map((field, index) => (
                <>
                  {formValues[field?.fieldName] !== '' && (
                    <div key={index}>
                      <h6 className='label'>{t(field?.fieldLabel)}</h6>
                      <h6 className='value'>{formValues[field?.fieldName]}</h6>
                    </div>
                  )}
                </>
              ))}
            </>
          )}

        <div>
          <h6 className='label'>
            {' '}
            {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT)}
          </h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.amount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.QUICKPAY_CHARGE)}
          </h6>
          <h6 className='value'>
            <NumberFormat
              value={responseValues?.charges || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>
        {/* <div>
          <h6 className='label'>Debit Amount</h6>
          <h6 className='value'>
            <NumberFormat
              value={responseValues.debitAmount || 0}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
            />
          </h6>
        </div> */}
        <div>
          <h6 className='label'>
            {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
          </h6>
          <h6 className='value'>
            {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
          </h6>
        </div>

        <div>
          <h6 className='label'>
            {t(BENEFICIARY_TRANSFER_KEYS.ADD_BENEFICIARY_BANK_KEYS.ADD_AS_BENEFICIARY)}
          </h6>
          <h6 className='value'>{formValues.addBene ? 'Yes' : 'No'}</h6>
        </div>
        <div>
          <TermsAndCondition module='FUNDTRANSFER' />
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CONFIRM_BUTTON)}
              mode='newDesign'
              onClick={async () => {
                otpEnable ? setStage(3) : await confirmInstantTransfer()
              }}></NeoButton>
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
        </div>
      </div>
    )
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
